"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _BaseComponents = require("../../../StyledComponents/BaseComponents");
var _services = require("../../../../services");
var _SpecContent = _interopRequireDefault(require("../../../Comparison/ComparisonDataDisplaySubComponents/SpecContent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FlexWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  text-align: center;
  border-bottom: 1px solid #bebebe;
  &:last-child {
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
  }
`;
const GrayCell = (0, _styledComponents.default)((0, _BaseComponents.GrayBackground)('div'))`
  padding: 0 20px;
  min-height: 73px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const LightCell = (0, _styledComponents.default)((0, _BaseComponents.LightBackground)('div'))`
  padding: 0 20px;
  min-height: 73px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const HeadingWrapper = _styledComponents.default.div`
  height: 52px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #bebebe;
`;
const ColorsGrayCell = (0, _styledComponents.default)((0, _BaseComponents.GrayBackground)('div'))`
  height: 73px;
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  height: max-content;
  padding-bottom: 15px;
  padding-top: 10px;
  ${_r10SourceLibrary.Mixins.respondTo.md(` gap: 60px;`)}
`;
const EntelCharacteristicsTab = _ref => {
  var _handset$color, _handset$color$value, _handset$groupedChara;
  let {
    handset,
    handsetIndex
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(FlexWrapper, null, /*#__PURE__*/_react.default.createElement(FlexWrapper, null, /*#__PURE__*/_react.default.createElement(HeadingWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    text: _services.locale.localeString('SpecsGroup.Colors'),
    size: 1,
    noMargin: true,
    weight: 3,
    dataAttributes: {
      'data-test-id': `characteristic-feature-0-${handsetIndex}`
    }
  })), /*#__PURE__*/_react.default.createElement(ColorsGrayCell, {
    "data-test-id": `characteristic-feature-values-0-${handsetIndex}`
  }, handset === null || handset === void 0 ? void 0 : (_handset$color = handset.color) === null || _handset$color === void 0 ? void 0 : (_handset$color$value = _handset$color.value) === null || _handset$color$value === void 0 ? void 0 : _handset$color$value.map((rawValue, index) => {
    var _rawValue$value, _rawValue$value2;
    const value = {
      text: rawValue === null || rawValue === void 0 ? void 0 : (_rawValue$value = rawValue.value) === null || _rawValue$value === void 0 ? void 0 : _rawValue$value.split('|')[1],
      colorValue: rawValue === null || rawValue === void 0 ? void 0 : (_rawValue$value2 = rawValue.value) === null || _rawValue$value2 === void 0 ? void 0 : _rawValue$value2.split('|')[0]
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_SpecContent.default, {
      label: 'Colors',
      value: value,
      applyShowDifferences: false,
      showColorToolTip: true
    }));
  }))), handset === null || handset === void 0 ? void 0 : (_handset$groupedChara = handset.groupedCharacteristics) === null || _handset$groupedChara === void 0 ? void 0 : _handset$groupedChara.map((characteristicGroup, indx) => {
    var _characteristicGroup$;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: indx
    }, /*#__PURE__*/_react.default.createElement(FlexWrapper, null, /*#__PURE__*/_react.default.createElement(HeadingWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      text: _services.locale.localeString(`SpecsGroup.${characteristicGroup.name}`),
      size: 1,
      weight: 3,
      dataAttributes: {
        'data-test-id': `characteristic-feature-${indx + 1}-${handsetIndex}`
      },
      noMargin: true
    })), characteristicGroup === null || characteristicGroup === void 0 ? void 0 : (_characteristicGroup$ = characteristicGroup.specs) === null || _characteristicGroup$ === void 0 ? void 0 : _characteristicGroup$.map((characteristic, index) => {
      const value = characteristicGroup.name === 'Colors' ? {} : {
        text: characteristic.valueText,
        subText: characteristic.name
      };
      return index % 2 === 0 ? /*#__PURE__*/_react.default.createElement(GrayCell, {
        key: index,
        "data-test-id": `characteristic-feature-values-${indx + 1}-${handsetIndex}`
      }, /*#__PURE__*/_react.default.createElement(_SpecContent.default, {
        label: characteristicGroup.name,
        value: value,
        applyShowDifferences: false
      })) : /*#__PURE__*/_react.default.createElement(LightCell, {
        key: index,
        "data-test-id": `characteristic-feature-values-${indx + 1}-${handsetIndex}`
      }, /*#__PURE__*/_react.default.createElement(_SpecContent.default, {
        label: characteristicGroup.name,
        value: value,
        applyShowDifferences: false
      }));
    })));
  }));
};
var _default = EntelCharacteristicsTab;
exports.default = _default;